import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Colors } from '../../styles/colors';

const ErrorMessage = styled.p`
  ${tw`text-red-500 text-sm mt-1`}
`;

interface PercentageSelectProps {
  value: number;
  onChange: (value: number) => void;
  minValue?: number;
  maxValue?: number;
  isInvalid?: boolean;
  errorMessage?: string;
}

const PercentageSelect: React.FC<PercentageSelectProps> = ({
  value,
  onChange,
  minValue = 0,
  maxValue = 99,
  isInvalid = false,
  errorMessage,
}) => {
  return (
    <div>
      <div className="relative h-10 flex items-center w-full max-w-md">
        <select
          value={value}
          onChange={e => onChange(Number(e.target.value))}
          className={`
            w-full h-10 
            border 
            rounded-lg 
            text-gray-900 
            text-right 
            pr-12 
            appearance-none 
            bg-white 
            flex 
            items-center 
            leading-[40px]
            ${isInvalid ? 'border-red-500' : 'border-gray-300'}
            ${isInvalid ? 'ring-1 ring-red-500' : ''}
          `}
          style={{
            paddingTop: '0',
            paddingBottom: '0',
            lineHeight: '40px',
            height: '40px',
            width: '100%',
            borderColor: isInvalid ? Colors.Error : Colors.Gray300,
          }}
        >
          {Array.from({ length: maxValue - minValue + 1 }, (_, i) => minValue + i).map(value => (
            <option key={value} value={value}>
              {`${value}%`}
            </option>
          ))}
        </select>
      </div>
      {isInvalid && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </div>
  );
};

export default PercentageSelect;
